import axios from 'axios';
import { getAuth } from 'firebase/auth';

const API_BASE_URL = '/.netlify/functions';

async function getIdToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Użytkownik nie jest zalogowany');
  return user.getIdToken(/* forceRefresh= */ true);
}

export const fetchAdvertisementSuggestions = async (platform, description) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-advertisement-suggestions`,
      { platform, description },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching advertisement suggestions:', error.message);
    throw new Error(
      'Wystąpił błąd podczas generowania ogłoszeń. Spróbuj ponownie później.'
    );
  }
};

export const fetchAdvertisementDetails = async (title, description, platform, userDescription) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-advertisement-details`,
      { title, description, platform, userDescription },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching advertisement details:', error.message);
    throw new Error(
      'Wystąpił błąd podczas generowania szczegółów ogłoszenia. Spróbuj ponownie później.'
    );
  }
};